const ACCESSIBLE_GROUPS_CACHE_KEY = 'accessibleGroupsCache';

let memoryCache = null;

/**
 * Session + in-memory cache of GET /group/accessible results.
 * Lets GroupSelectDropdown decide show/hide before the network returns.
 */
export function getCachedAccessibleGroups() {
  if (typeof window === 'undefined') return null;
  if (Array.isArray(memoryCache)) return memoryCache;
  try {
    const raw = sessionStorage.getItem(ACCESSIBLE_GROUPS_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    memoryCache = parsed;
    return parsed;
  } catch {
    return null;
  }
}

export function setCachedAccessibleGroups(groups) {
  if (!Array.isArray(groups)) return;
  memoryCache = groups;
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(ACCESSIBLE_GROUPS_CACHE_KEY, JSON.stringify(groups));
  } catch {
    // ignore quota / private mode
  }
}

export function clearCachedAccessibleGroups() {
  memoryCache = null;
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(ACCESSIBLE_GROUPS_CACHE_KEY);
  } catch {
    // ignore
  }
}
